import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

import bkashLogo from "../assets/icons/bkash.png";
import nagadLogo from "../assets/icons/nagad.png";
import rocketLogo from "../assets/icons/rocket.png";

const PaymentPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const amount = Number(query.get("amount")) || 0;
  const method = query.get("methodName") || "বিকাশ";

  // ================= STATES =================
  const [trxId, setTrxId] = useState("");
const [loading, setLoading] = useState(false);
const [popupVisible, setPopupVisible] = useState(false);

    const [settings, setSettings] = useState({
    bkash: {
      number: "",
      instruction: "",
    },
    nagad: {
      number: "",
      instruction: "",
    },
    rocket: {
      number: "",
      instruction: "",
    },
  });

  /* ================= LOAD ADMIN SETTINGS ================= */
 useEffect(() => {
  const load = async () => {
    try {
      const res = await axios.get(
        "https://api.earnmoney0.top/api/payment-methods"
      );

      const data = {
        bkash: { number: "", instruction: "" },
        nagad: { number: "", instruction: "" },
        rocket: { number: "", instruction: "" },
      };

      res.data.forEach((m) => {
        if (m.name === "বিকাশ") {
          data.bkash = {
            number: m.number,
            instruction: m.instruction || "",
          };
        }
        if (m.name === "নগদ") {
          data.nagad = {
            number: m.number,
            instruction: m.instruction || "",
          };
        }
        if (m.name === "রকেট") {
          data.rocket = {
            number: m.number,
            instruction: m.instruction || "",
          };
        }
      });

      setSettings(data);
    } catch (e) {
      console.error("Payment settings load failed", e);
    }
  };
  load();
}, []);

  /* ================= MINIMUM 300 HARD CHECK ================= */
  useEffect(() => {
    if (amount < 300) {
      alert("Minimum deposit is 300 BDT");
      navigate("/deposit");
    }
  }, [amount, navigate]);

  /* ================= TRANSACTION VALIDATOR ================= */
  const isValidTrxId = (trx) => {
    const clean = trx.trim();
    if (!/^[A-Z0-9]+$/.test(clean)) return false;
    if (clean.length < 8 || clean.length > 15) return false;
    if (/[a-z]/.test(clean)) return false;
    return true;
  };

  /* ================= CONFIRM ================= */

const handleConfirm = async () => {
  const user = JSON.parse(localStorage.getItem("user"));

if (!user || !user.id) {
  alert("User not logged in!");
  navigate("/login");
  return;
}

const userId = user.id;

  if (!trxId) {
    alert("Transaction ID required");
    return;
  }

  if (!isValidTrxId(trxId)) {
    alert("আপনার দেওয়া ট্রানজেকশন ভুল ❌ পরবর্তী তে টাকা না পাঠিয়ে রিকুয়েষ্ট পাঠানের চেষ্টা করলে একাউন্ট ব্যান করা হবে 🚫");
    return;
  }

  setLoading(true);

  try {
    await axios.post("https://api.earnmoney0.top/api/fund/request", {
      userId,
      transactionId: trxId,
      method,
      number: selectedNumber,
      amount,
    });

    setPopupVisible(true);
  } catch (e) {
    console.error(e);
    alert("এই ট্রানজেকশন ইতিমধ্যে ব্যবহার হয়েছে 🚫 অপেক্ষা করুন");
  } finally {
    setLoading(false);
  }
};

  const methodKey =
  method === "বিকাশ"
    ? "bkash"
    : method === "নগদ"
    ? "nagad"
    : method === "রকেট"
    ? "rocket"
    : "bkash";

const logos = {
  bkash: bkashLogo,
  nagad: nagadLogo,
  rocket: rocketLogo,
};

const selectedLogo = logos[methodKey];
const selectedNumber = settings[methodKey]?.number;
const selectedInstructions = settings[methodKey]?.instruction;

  return (
    <div style={styles.page}>
      {/* HEADER */}
      <div style={styles.header}>
        <button onClick={() => navigate(-1)} style={styles.backBtn}>
          ←
        </button>
        <h2 style={styles.headerTitle}>Payment</h2>
      </div>

      {/* CARD */}
      <div style={styles.card}>
        <div style={styles.methodRow}>
          <img src={selectedLogo} alt={method} style={styles.logo} />
          <div>
            <h3>{method} Sent Money</h3>
            <p style={{ color: "#555" }}>Send exactly ৳{amount}</p>
          </div>
        </div>

       <div style={styles.infoBox}>

{method === "বিকাশ" && (
  <img
    src="/bkashset.png"
    alt="bkash banner"
    style={styles.bkashBanner}
  />
)}

<strong>বিকাশ পেমেন্ট</strong>
  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
    <p style={styles.number}>{selectedNumber}</p>
    <button
  style={{
    background: "#7a0f7a",
    color: "#fff",
    border: "none",
    padding: "4px 8px",
    borderRadius: 6,
    cursor: "pointer",
    fontSize: 14,
  }}
  onClick={() => {
    navigator.clipboard.writeText(selectedNumber);
    const toast = document.createElement("div");
    toast.innerText = "Copied successfully ✅";
    toast.style.position = "fixed";
    toast.style.top = "20px";
    toast.style.left = "50%";
    toast.style.transform = "translateX(-50%)";
    toast.style.background = "#7a0f7a";
    toast.style.color = "#fff";
    toast.style.padding = "8px 14px";
    toast.style.borderRadius = "8px";
    toast.style.boxShadow = "0 2px 6px rgba(0,0,0,0.2)";
    toast.style.zIndex = 1000;
    document.body.appendChild(toast);
    setTimeout(() => {
      toast.remove();
    }, 1500);
  }}
>
  Copy
</button>
  </div>
</div>

        <div style={styles.inputGroup}>
          <label>Transaction ID</label>
          <input
            value={trxId}
            onChange={(e) => setTrxId(e.target.value.toUpperCase())}
            placeholder="Enter transaction ID"
            style={styles.input}
          />
        </div>

        {/* ================= CONFIRM BUTTON ================= */}
<button
  onClick={handleConfirm}
  style={styles.confirmBtn}
  disabled={loading}
>
  {loading ? "Processing..." : "VERIFY PAYMENT"}
</button>

{/* ================= SUCCESS POPUP ================= */}
{popupVisible && (
  <div style={styles.popupOverlay}>
    <div style={styles.popup}>
      <h3>🎉 আপনার Fund Request গ্রহন করা হয়েছে!</h3>
      <p>খুব দ্রুত Approved করা হবে 🎁</p>
      <button
        onClick={() => navigate("/deposit")}
        style={styles.popupBtn}
      >
        Ok
      </button>
    </div>
  </div>
)}

        <div style={styles.instructions}>
          <strong>Instructions</strong>
          <ul>
  {(selectedInstructions || "")
    .split("\n")
    .map((s, i) => (
      <li key={i}>{s}</li>
    ))}
</ul>
        </div>
      </div>
    </div>
  );
};

export default PaymentPage;

/* ================= STYLES ================= */

const styles = {
  page: {
    minHeight: "100vh",
    background: "#f3f4f6",
  },

  header: {
    background: "#7a0f7a",
    color: "#fff",
    padding: "15px",
    display: "flex",
    alignItems: "center",
    gap: 10,
  },

  backBtn: {
    background: "transparent",
    border: "none",
    color: "#fff",
    fontSize: 22,
    cursor: "pointer",
  },

  headerTitle: {
    margin: 0,
    fontSize: 20,
  },

  card: {
    background: "#fff",
    margin: 15,
    padding: 20,
    borderRadius: 14,
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  },

  methodRow: {
    display: "flex",
    gap: 15,
    alignItems: "center",
    marginBottom: 15,
  },

  logo: {
    width: 55,
    height: 55,
  },

  infoBox: {
    background: "#f9fafb",
    padding: 12,
    borderRadius: 10,
    marginBottom: 15,
  },

  bkashBanner: {
  width: "100%",
  borderRadius: 10,
  marginBottom: 10,
},

  number: {
    fontSize: 18,
    fontWeight: 700,
    marginTop: 4,
  },

  inputGroup: {
    marginBottom: 15,
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },

  input: {
    padding: 12,
    borderRadius: 8,
    border: "1px solid #ccc",
    fontSize: 16,
  },

  popupOverlay: {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 999,
},
popup: {
  background: "#fff",
  padding: 25,
  borderRadius: 12,
  textAlign: "center",
  maxWidth: 350,
  boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
},
popupBtn: {
  marginTop: 15,
  padding: "10px 25px",
  background: "#7a0f7a",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  fontWeight: 600,
  fontSize: 16,
},

confirmBtn: {
    width: "100%",
    padding: 14,
    background: "#7a0f7a",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    fontWeight: 700,
    fontSize: 16,
    cursor: "pointer",
  },

  instructions: {
    marginTop: 20,
    fontSize: 14,
    color: "#444",
  },
};